var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tex"},[_c('div',{staticClass:"tex__inner"},[_c('h1',{staticClass:"tex__title"},[_vm._v(_vm._s(_vm.$t("tutored.title")))]),_c('p',{staticClass:"tex__lead"},[_vm._v(" "+_vm._s(_vm.$t("tutored.lead"))+" ")]),_c('student-exercise-overview',{attrs:{"empty-text":_vm.$t('tutored.empty')}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }